import {Environment, graphql} from 'react-relay';
import type {Disposable} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {
	UpdateInitialPlanProjectInput,
	UpdateInitialPlanProjectMutation,
} from './__generated__/UpdateInitialPlanProjectMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from './MutationTypes';

const mutation = graphql`
	mutation UpdateInitialPlanProjectMutation($input: UpdateInitialPlanProjectInput!) {
		updateInitialPlanProject(input: $input) {
			project {
				id
				baselineTargetMinutes
				baselineTargetPrice
				baselineCost
				baselineProfit
				baselineWinChance
				projectStartYear
				projectStartMonth
				projectStartDay
				projectEndYear
				projectEndMonth
				projectEndDay
				baselineTarget
				baselineEstimationMinutesPerDay
				budget
				rateCard {
					id
					currency
				}
				unassignedTaskHourlyCost
				taskCostCalculationType
				phases(first: 100000) @connection(key: "Project_phases", filters: []) {
					edges {
						node {
							id
							name
							startYear
							startMonth
							startDay
							deadlineYear
							deadlineMonth
							deadlineDay
							baselineStartYear
							baselineStartMonth
							baselineStartDay
							baselineDeadlineYear
							baselineDeadlineMonth
							baselineDeadlineDay
						}
					}
				}
			}
		}
	}
`;

type Input = MutationInput<UpdateInitialPlanProjectInput>;

function getConfigs() {
	return [];
}

function commit(
	environment: Environment,
	input: Input,
	onSuccess?: RelayOnCompleted<UpdateInitialPlanProjectMutation>,
	onError?: RelayOnError
): Disposable {
	const changes: string[] = [];

	for (const key of Object.keys(input) as (keyof Input)[]) {
		if (['id', 'project'].includes(key) || input[key] === undefined) {
			continue;
		}

		changes.push(key);
	}

	tracking.trackEvent('Project Updated', {_Changed: changes});

	return trackAndCommitMutation<UpdateInitialPlanProjectMutation>(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
